import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FloatingLabel } from "react-bootstrap";
import { toast } from "react-toastify";

const AdvanceBooking = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    checkIn: "",
    checkOut: "",
    adults: "2",
    children: "0",
    roomType: "",
    fullName: "",
    email: "",
    phone: "",
    remark: "",
  });
  const loginUser = JSON.parse(localStorage.getItem("loginUser"));

  const hotelId = loginUser?.hotelid;

  React.useEffect(() => {
    if (!loginUser) {
      navigate("/"); // login page
    }
  }, [loginUser, navigate]);

  /* ---------- HANDLE CHANGE ---------- */
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  /* ---------- SUBMIT ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      id: crypto.randomUUID(),
      booking_no: "ADV-" + Date.now(),
      room_type: formData.roomType,
      name: formData.fullName,
      email: formData.email,
      mobileno: formData.phone,
      checkin: formData.checkIn,
      checkout: formData.checkOut,
      adult_person: parseInt(formData.adults),
      child: parseInt(formData.children),
      remark: formData.remark || "Advance Room Booking",
      createdon: new Date().toISOString(),
    };

    try {
      await axios.post(
        `https://hotelapi.shriyanshnath.com/api/save_advance_booking?hotelid=${hotelId}`,
       
        payload
      );

      toast.success("Advance Booking Saved Successfully ✅");

      // reset form
      setFormData({
        checkIn: "",
        checkOut: "",
        adults: "2",
        children: "0",
        roomType: "",
        fullName: "",
        email: "",
        phone: "",
        remark: "",
      });
    } catch (error) {
      console.error(error);  
      toast.error("Failed to save booking  ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="px-4 my-4">
      <Row className="justify-content-center">
        <Col xl={10} lg={11}>
          <Card className="shadow-sm">
            <Card.Body>
              {/* HEADER */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">
                  📅 <strong>Booking Details</strong>
                </h5>

                {/* 👉 VIEW BOOKINGS BUTTON */}
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => navigate("/advance-booking-history")}
                >
                  View Bookings
                </Button>
              </div>

              <Form onSubmit={handleSubmit}>
                {/* DATES */}
                <Row className="mb-3 g-3">
                  {/* CHECK-IN DATE */}
                  <Col md={6}>
                    {/* Mobile View */}
                    <div className="d-md-none">
                      <FloatingLabel label="Check-in Date *">
                        <Form.Control
                          type="date"
                          name="checkIn"
                          value={formData.checkIn}
                          onChange={handleChange}
                          required
                        />
                      </FloatingLabel>
                    </div>

                    {/* Desktop View */}
                    <div className="d-none d-md-block">
                      <Form.Label>
                        Check-in Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="checkIn"
                        value={formData.checkIn}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>

                  {/* CHECK-OUT DATE */}
                  <Col md={6}>
                    {/* Mobile View */}
                    <div className="d-md-none">
                      <FloatingLabel label="Check-out Date *">
                        <Form.Control
                          type="date"
                          name="checkOut"
                          value={formData.checkOut}
                          onChange={handleChange}
                          required
                        />
                      </FloatingLabel>
                    </div>

                    {/* Desktop View */}
                    <div className="d-none d-md-block">
                      <Form.Label>
                        Check-out Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="checkOut"
                        value={formData.checkOut}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>

                {/* GUESTS */}
                <Form.Label>
                  Number of Guests <span className="text-danger">*</span>
                </Form.Label>

                <Row className="mb-3 g-3">
                  <Col md={6}>
                    <Form.Select
                      name="adults"
                      value={formData.adults}
                      onChange={handleChange}
                    >
                      <option value="1">1 Adult</option>
                      <option value="2">2 Adults</option>
                      <option value="3">3 Adults</option>
                      <option value="4">4 Adults</option>
                    </Form.Select>
                  </Col>

                  <Col md={6}>
                    <Form.Select
                      name="children"
                      value={formData.children}
                      onChange={handleChange}
                    >
                      <option value="0">0 Children</option>
                      <option value="1">1 Child</option>
                      <option value="2">2 Children</option>
                    </Form.Select>
                  </Col>
                </Row>

                {/* ROOM TYPE */}
                <Form.Group className="mb-3">
                  <Form.Label>
                    Room Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="roomType"
                    value={formData.roomType}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Room Type</option>
                    <option value="AC Deluxe">AC Deluxe</option>
                    <option value="Non AC">Non AC</option>
                    <option value="Suite">Suite</option>
                  </Form.Select>
                </Form.Group>

                {/* PERSONAL INFO */}
                <h5 className="mt-4 mb-3">
                  👤 <strong>Personal Information</strong>
                </h5>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Full Name *</Form.Label>
                      <Form.Control
                        name="fullName"
                        placeholder="Enter full name"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email *</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Mobile No *</Form.Label>
                      <Form.Control
                        name="phone"
                        placeholder="Enter mobile number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Remark</Form.Label>
                      <Form.Control
                        name="remark"
                        placeholder="Optional remark"
                        value={formData.remark}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* SUBMIT */}
                <Button type="submit" className="w-100 mt-3" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner size="sm" animation="border" className="me-2" />
                      Saving...
                    </>
                  ) : (
                    "Submit Advance Booking"
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdvanceBooking;
